// removed by extract-text-webpack-plugin
module.exports = {"brokerage-wrap":"brokerage-wrap___2FlVt","no-brokerage-wrap":"no-brokerage-wrap___1clJb","brokerage-inner":"brokerage-inner___3lMLx","brokerage-flex":"brokerage-flex___3h1BE center___2iqBf space-top-6___2l-qx space-bottom-6___3i22S","brokerage-flex-label":"brokerage-flex-label___3ukb6 h3___5u0xZ","brokerage-flex-text":"brokerage-flex-text___2zPq_ h2___hzLuT","brokerage-flex-sublede":"brokerage-flex-sublede___1FK4- h4___kHWTn","white-xstrong":"white-xstrong___2g4Du","brokerage-icon":"brokerage-icon___nPP5- center___2iqBf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardSelfDirectedOption/PlanScorecardSelfDirectedOption.css
// module id = 909
// module chunks = 0